import * as React from 'react'
import BaseIcon from 'react-icon-base'

const LikeIcon = props => (
  <BaseIcon width="12" height="11" viewBox="0 0 12 11" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.667 4C1.85 4 2 4.157 2 4.35v6.3c0 .193-.15.35-.333.35H.333A.342.342 0 0 1 0 10.65v-6.3C0 4.157.15 4 .333 4h1.334zm6.277-.231s2.999-.011 3.063 0c1.06.181 1.364 1.634.456 2.22.308.55.128 1.267-.398 1.608.308.55.129 1.266-.397 1.607.44.788-.145 1.797-1.04 1.796H3V4.572S4.918 2.817 5.536 2.21c.354-.349.582-.814.674-1.302.036-.193.026-.396.127-.57A.664.664 0 0 1 6.743.03c.294-.075.659-.004.92.137.802.433.989 1.65.7 2.448l-.419 1.154z"
    />
  </BaseIcon>
)

export default LikeIcon
